import React from 'react';
import './espaceetudiant.css';
import { Link } from 'react-router-dom';
import Header from './Header';


function Espaceetudiant(props) {
  return (
    <>
    <Header/>

       <div className='choixetudiantespace'>
       <Link to="/DashbordEtudiant/Nouveauté"><div className='choixetudiant' style={{backgroundColor:'#FF9843'}}>
          <ion-icon name="newspaper-outline"></ion-icon>
          <br/>
            Nouveautés
          </div>
         </Link>
         <Link to="/DashbordEtudiant/Messagerie">
         <div className='choixetudiant'style={{backgroundColor:'#86A7FC'}}>
         <ion-icon name="mail-outline"></ion-icon>
         <br/>
           Messagerie
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Fiche étudiant">
         <div className='choixetudiant'style={{backgroundColor:'#3468C0'}}>
         <i class="fa-regular fa-address-card" style={{marginBottom:'10px'}}></i>
         <br/>
           Fiche étudiant
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Emploi de temps">
         <div className='choixetudiant'style={{backgroundColor:'#FFDD95'}}>
         <ion-icon name="calendar-outline"></ion-icon>
         <br/>
          Emploi de temps 
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Calendrier des examens">
         <div className='choixetudiant'style={{backgroundColor:'#333A73'}}>
         <ion-icon name="calendar-number-outline"></ion-icon>
         <br/>
          Calendrier des examens
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Liste des avis d'absence">
         <div className='choixetudiant'style={{backgroundColor:'#4CB9E7'}}>
         <ion-icon name="person-outline"></ion-icon>
         <br/>
         Liste des avis d'absence
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Avis de rattrapages">
         <div className='choixetudiant'style={{backgroundColor:'#FF6C22'}}>
         <i class="fa-solid fa-chalkboard-user"></i>        
          <br/>
         Avis de rattrapages
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Avis d'examens">
         <div className='choixetudiant'style={{backgroundColor:'#FFD099'}}>
         <ion-icon name="reader-outline"></ion-icon>       
         <br/>
         Avis d'examens
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Bibliothèque">
         <div className='choixetudiant'style={{backgroundColor:'#2B3499'}}>
         <ion-icon name="library-outline"></ion-icon>
         <br/>
         Bibliothèque
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Demandes en ligne">
         <div className='choixetudiant'style={{backgroundColor:'#B4BDFF'}}>
         <i class="fa-solid fa-thumbtack"></i>
         <br/>
         Demandes en ligne
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Délebération">
         <div className='choixetudiant'style={{backgroundColor:'#0802A3'}}>
         <i class="fa-solid fa-graduation-cap" style={{marginBottom:'20px'}}></i>       
          <br/>
         Délebération
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Liste des supports pédagogiques">
         <div className='choixetudiant'style={{backgroundColor:'#E8630A'}}>
         <ion-icon name="list-outline"></ion-icon>
         <br/>
         Liste des supports pédagogiques
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Espace Téléchrgement">
         <div className='choixetudiant'style={{backgroundColor:'#64C9CF'}}>
         <i class="fa-solid fa-download"></i>
          <br/>
          Espace Téléchrgement
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Stage et PFE">
         <div className='choixetudiant'style={{backgroundColor:'#EC5858'}}>
         <i class="fa-solid fa-building-columns" style={{marginBottom:'20px'}}></i>         
         <br/>
         Stage et PFE
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Stage facultatifs">
         <div className='choixetudiant'style={{backgroundColor:'#FFA372'}}>
         <ion-icon name="business-outline"></ion-icon>         <br/>
         Stage facultatifs
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Stage Obligatoire">
         <div className='choixetudiant'style={{backgroundColor:'#5F6CAF'}}>
         <ion-icon name="business-outline"></ion-icon> <br/>
         Stage Obligatoire
         </div>
         </Link>
         <Link to="/DashbordEtudiant/Boite de proposition">
         <div className='choixetudiant'style={{backgroundColor:'#8F4426'}}>
         <i class="fa-solid fa-box-tissue"></i> 
         <br/>       
          Boite de proposition
         </div>
         </Link>

         <div className='divextra' style={{height:'200px',width:'200px'}}>
         </div>

         <div  className='divextra'  style={{height:'200px',width:'200px'}}>
         </div>

         <div  className='divextra'  style={{height:'200px',width:'200px'}}>
         </div>


       
       </div>
    </>
  );
}

export default Espaceetudiant;